import type { Translator } from '~/utils/translations/buildTranslate';

// Google cuts a title past about 60 characters
const MAX_TITLE_LENGTH = 60;

/** The offer page's title: with the "job offer" suffix when it fits, as the heading alone otherwise. */
export const getMissionPageTitle = (
  t: Translator,
  { title, city, areaCode }: { title: string; city: string; areaCode?: string },
) => {
  const variant = areaCode ? 'with_area' : 'without_area';
  const params = { title, city, areaCode };
  const fullTitle = t(`missions.mission_title.${variant}`, params);
  return fullTitle.length <= MAX_TITLE_LENGTH ? fullTitle : t(`missions.mission_h1.${variant}`, params);
};
